import useSWR from 'swr';

import { I_Badge } from 'containers/Badge/interface';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export const useBadge = (id: number) => {
  const {
    data: { data } = {},
    isLoading,
    isValidating,
    error,
    mutate
  } = useSWR<IDetailResponse<I_Badge>>(id ? `/v4/dash/badges/${id}` : null, fetcher);

  return { data, isLoading, isValidating, error, mutate };
};

export const useBadgeList = (params: Record<string, any>) => {
  const {
    data: { data, meta } = {},
    isLoading,
    isValidating,
    error,
    mutate
  } = useSWR<IPaginatedResponse<I_Badge>>(`/v4/dash/badges?${buildQuery(params)}`, fetcher);

  return { data, meta, isLoading, isValidating, error, mutate };
};
